import * as Types from 'redux/playtesterV2/actions/types'

import { generateInitialState } from 'redux/playtesterV2/initialState'

import { PlaytesterV2Actions } from 'redux/playtesterV2/actions'

import { PlaytesterV2State } from 'redux/playtesterV2/types'

import { createUndoState, getUndoRedo } from 'redux/playtesterV2/helpers/undoRedo'
import { writeChangesToLocalStorage } from 'redux/playtesterV2/helpers/cacheStateChanges'
import { logCardMoves } from 'redux/playtesterV2/helpers/logCardMoves'
import { generateSharablePlaytesterState } from 'redux/playtesterV2/helpers/sharablePlaytesterHelper'

import playteserService from 'services/playtester.service'

const handler: (state: PlaytesterV2State, action: PlaytesterV2Actions) => PlaytesterV2State = (
  state = generateInitialState(),
  action,
) => {
  switch (action.type) {
    case Types.SET_PLAYTESTER_V2_STATE:
      // Don't write to local storage in a shared window
      if (!state.sharedWindow) writeChangesToLocalStorage(action.payload)

      const gameLog = logCardMoves(state, action.payload)
      const undoRedoState = createUndoState(state, action.payload)

      const shareableState = generateSharablePlaytesterState(action.payload, state)

      if (shareableState) playteserService.send(shareableState, 'SET_PLAYTESTER_V2_STATE')

      const updatedState = { ...state, ...undoRedoState, gameLog, ...action.payload }

      return {
        ...updatedState,
        cardSize: updatedState.autoCardSizeEnabled ? updatedState.autoCardSize : updatedState.manualCardSize,
        handSize: updatedState.autoHandSizeEnabled ? updatedState.autoHandSize : updatedState.manualHandSize,
      }

    case Types.UNDO_PLAYTESTER_V2:
    case Types.REDO_PLAYTESTER_V2:
      const undoneRedoneState = getUndoRedo(state, action.type === Types.UNDO_PLAYTESTER_V2)

      return { ...state, ...undoneRedoneState }

    default:
      return state
  }
}

export default handler
